import { runtime } from '../../runtime/Runtime';
export class AppHostname {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get app() {
        return this.parent;
    }
    get mainHostname() {
        // without port
        return window.location.hostname;
    } // e.g. dev.schlaukopf.de
    get nodeHostName() {
        return runtime.runtimeHostname.nodeHostName;
    }
    get mainHref() {
        return `https://${this.mainHostname}`;
    }
    get nodeHref() {
        return `https://${this.nodeHostName}`;
    }
    get dataHref() {
        return `https://${runtime.runtimeHostname.dataHostName}`;
    }
    get data2Href() {
        return `https://${runtime.runtimeHostname.data2HostName}`;
    }
    get domainEnding() {
        const p = this.mainHostname.split('.');
        return p.length > 2 ? p[2] : '';
    }
}
